import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

export default function TradeCatalog() {
  const [trades, setTrades] = useState([]);
  const [sectors, setSectors] = useState([]);
  useEffect(() => {
    api.get("/trade-catalog").then(r => setTrades(r.data));
    api.get("/service-lines").then(r => setSectors(r.data));
  }, []);
  return (
    <AppShell
      title="Trade & Sector Catalog"
      subtitle="Reference data for ERF Enterprises · consumed by Estimating, Bidding, Sub Network (Phase 2+)"
    >
      <div className="grid gap-6 md:grid-cols-2">
        <section>
          <div className="text-xs uppercase font-nav text-erf-dark/60 mb-2 tracking-widest">Trades ({trades.length})</div>
          <div className="bg-white border border-erf-borderCream rounded-md p-4 flex flex-wrap gap-2" data-testid="trade-catalog-list">
            {trades.map(t => (
              <span key={t.key} className="mono text-[11px] px-2 py-1 rounded-sm bg-erf-creamSecondary border border-erf-borderCream text-erf-dark">
                {t.label}
              </span>
            ))}
          </div>
        </section>
        <section>
          <div className="text-xs uppercase font-nav text-erf-dark/60 mb-2 tracking-widest">Sectors ({sectors.length})</div>
          <div className="bg-white border border-erf-borderCream rounded-md p-4 flex flex-wrap gap-2" data-testid="service-lines-list">
            {sectors.map(s => (
              <span key={s.key} className="mono text-[11px] px-2 py-1 rounded-sm bg-erf-gold/10 border border-erf-gold/40 text-erf-dark">
                {s.label}
              </span>
            ))}
          </div>
        </section>
      </div>
    </AppShell>
  );
}
